// extracted by mini-css-extract-plugin
export default {"melodyVideo":"AL-z","isFullWidth":"BL-z","landingPageVideo":"CL-z","play":"DL-z","iframeVideo":"EL-z","playHidden":"FL-z","fullwidth":"GL-z"};